import Loadable from '../../components/loadable';

const SequencesList = Loadable({
  loader: () => import('react/pages/sequences/sequences_list/sequences_list'),
  type: 'block',
});

angular.module('gym').value('SequencesList', SequencesList);

const SequencesListFiltersModal = Loadable({
  loader: () => import('react/pages/sequences/sequences_list/sequences_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('SequencesListFiltersModal', SequencesListFiltersModal);
